module.exports = __webpack_public_path__ + "static/assinatura-digital-tooltip-9824c10f640dc34ada4eebcd09749388.svg";